// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import { useDurationText, usePriceText } from '../modules';

type Props = {
  minDuration: number,
  price: number,
  priceDiff?: number,
  showFromPrice?: boolean,
  currency: string,
  children?: React.Node,
  durationChange?: 'unchanged' | 'renew' | 'reset' | string,
};

// TODO: uniformize with `PriceText` component
export function CatalogPrice({
  minDuration,
  price,
  priceDiff,
  showFromPrice = false,
  currency,
  children,
  durationChange,
}: Props): React.MixedElement {
  const timeLimited = !!priceDiff || minDuration > 1;
  const durationText = useDurationText({
    durationChange,
    minDuration,
    timeLimited,
  });

  const priceText = usePriceText({
    price,
    minDuration,
    // TODO: uniformize: the hook itself should check if the product is in the cart (with a selected
    // phase), calling the useExtendedSuggestion, instead of passing props everywhere.
    needsPhaseSelection: showFromPrice,
    currency,
    boldPrice: true,
  });

  return (
    <Base>
      <Base flex gap="xsmall" flexJustifyEnd>
        {/* duration + normal price */}
        <Base flex gap="xxsmall">
          {durationText && timeLimited ? <span>{durationText} </span> : null}
          {priceText}
          {durationText && !timeLimited ? <span>{durationText} </span> : null}
        </Base>
      </Base>
      {children}
    </Base>
  );
}
